const i = {
  /**
   * Returns brand color shema default value
   * @returns {Array<{name: string, shade: number}>} array of shades objects with name and shade value
   */
  getBrandColorModel() {
    return [
      {
        name: "brand"
      },
      {
        name: "brand-light-1",
        shade: 5
      },
      {
        name: "brand-light-2",
        shade: 15
      },
      {
        name: "brand-light-3",
        shade: 30
      },
      {
        name: "brand-dark",
        shade: -5
      },
      {
        name: "brand-contrast"
      }
    ];
  },
  /**
   * Sets color shades by color and colorModel
   * @param {Object} color The color object
   * @param {string} color.cssName The color name
   * @param {string} color.value The color hex
   * @param {Array} colorModel The color model of tints and shades
   * @param {Object} [envWindow] Window object, like $window for angular, etc.
   */
  setColorStyles(t, e, r) {
    const s = this.generateColorShades(t, e);
    this.setColorShades(s, r);
  },
  /**
   * Sets color shades to the root styles
   * @param {Object} shades The color object of color variable name as a property and hex as a vaue
   * @param {Object} [envWindow] Window object, like $window for angular, etc.
   */
  setColorShades(t, e) {
    const r = e ? e.document.documentElement.style : document.documentElement.style;
    Object.keys(t).forEach((n) => {
      r.setProperty(n, t[n]);
    });
  },
  /**
   * Generates shades for color via color model
   * @param {Object} color The color object
   * @param {string} color.cssName The color name
   * @param {string} color.value The color hex
   * @param {Array} colorModel The color model of tints and shades
   * @returns {Object}} Object of brand color shades in structure of css variables
   */
  generateColorShades({ cssName: t = "color", value: e }, r) {
    if (!e || !r)
      return {};
    const s = {};
    return r.forEach(({ name: n, shade: o }) => {
      const a = `--${t}-${n}`;
      s[a] = this.getColorShade(e, n, o), s[`${a}-code`] = Object.values(
        this.hexToRgb(s[a])
      ).join(", ");
    }), s;
  },
  /**
   * Generates shade for color depending on color shade name and shade value property
   * @param {string} colorValue A hex code of a color
   * @param {string} shadeName A name of a shade
   * @param {number} shadeValue A shade number deviation from the main color
   * @returns {string} A hex code of a shade color
   */
  getColorShade(t, e, r) {
    return e === "brand" ? t : e === "brand-contrast" ? this.getColorContrast(t) : this.getColorLuminance(t, r, !0);
  },
  hexToRgb(t) {
    const e = t.substring(1), r = parseInt(e, 16), s = r >> 16 & 255, n = r >> 8 & 255, o = r >> 0 & 255;
    return {
      r: s,
      g: n,
      b: o
    };
  },
  /**
   * Returns color brightness expressed as a weighed average of R, G and B
   * @param {Object} rgb
   * @returns {number}
   */
  getBrightness(t) {
    return (t.r * 299 + t.g * 587 + t.b * 114) / 1e3;
  },
  isDark(t) {
    return this.getBrightness(t) < 125;
  },
  isVeryDark(t) {
    return this.getBrightness(t) < 55;
  },
  isLight(t) {
    return this.getBrightness(t) > 125;
  },
  isVeryLight(t) {
    return this.getBrightness(t) > 175;
  },
  // jshint -W016, -W074
  adjustLuminance(t, e) {
    const r = parseInt(t.substring(1), 16), s = Math.round(2.55 * e), n = (r >> 16) + s, o = (r >> 8 & 255) + s, a = (r & 255) + s;
    return `#${(16777216 + (n < 255 ? n < 1 ? 0 : n : 255) * 65536 + (o < 255 ? o < 1 ? 0 : o : 255) * 256 + (a < 255 ? a < 1 ? 0 : a : 255)).toString(16).slice(1)}`;
  },
  /**
   * Changes the luminance of a color to be lighter or darker. Positive values (0 to 100) produce lighter color, negative values (0 to -100) produce darker color.
   * `getColorLuminance('#2bb7ee', 10)` produces `#2fc9ff`, 10% lighter color.
   * @param {string} hex
   * @param {number} lum
   * @param {boolean} invertLuminance
   * @returns {string}
   */
  getColorLuminance(t, e, r) {
    const s = this.hexToRgb(t);
    let n;
    if (r)
      switch (!0) {
        case this.isVeryDark(s):
          n = e + 20;
          break;
        case this.isDark(s):
          n = e + 15;
          break;
        case this.isVeryLight(s):
          n = e - 20;
          break;
        case this.isLight(s):
          n = e - 15;
          break;
        default:
          n = e;
      }
    return this.adjustLuminance(t, n);
  },
  /**
   * Returns a contrasting color, either a shade of black or pure white
   * @param {string} hex
   * @returns {string}
   */
  getColorContrast(t) {
    const e = this.hexToRgb(t);
    return (e.r * 299 + e.g * 587 + e.b * 114) / 1e3 >= 175 ? "#556066" : "#ffffff";
  }
};
export {
  i as c
};
